import React from 'react';
import {
    AppBar as MuiAppBar,
    Box,
    Link,
    Stack,
    Toolbar,
    Typography,
} from '@mui/material';
import { themeVars } from '@mds/ui';
import { MarexLogo } from '@mds/assets';
import { InsightsLogoMark } from './InsightsLogoMark';

export const AppBar = ({ app = 'Insights' }: any) => (
    <MuiAppBar
        position="fixed"
        color="transparent"
        elevation={0}
        sx={{
            backgroundColor: 'var(--mds-palette-background-level1)',
            color: 'var(--mds-palette-text-primary)',
            boxShadow: 'none',
        }}
    >
        <Toolbar>
            <Stack
                direction="row"
                spacing={1.5}
                sx={{
                    alignItems: 'center',
                }}
            >
                <InsightsLogoMark />
                <Typography variant="h6">{app}</Typography>
            </Stack>
        </Toolbar>
    </MuiAppBar>
);

export const Footer = ({ sx, ...props }: any) => (
    <Box
        component="footer"
        sx={[
            {
                display: 'flex',
                alignItems: 'center',
                flexDirection: { xs: 'column', sm: 'row' },
                mt: 2,
                py: 2,
                px: 4,
            },
            ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
        ]}
        {...props}
    >
        <Link
            href="https://www.marex.com"
            target="_blank"
            rel="noreferrer"
            aria-label="Marex website"
            sx={{
                display: 'inline-flex',
                mb: { xs: 1, sm: 0 },
                mr: { xs: 0, sm: 4 },
                color: 'text.primary',
                '--logo-text-color': (theme) =>
                    themeVars(theme).palette.text.primary,
            }}
        >
            <MarexLogo style={{ height: 32, width: 'auto' }} />
        </Link>
        <Typography
            variant="caption"
            sx={{
                color: 'text.secondary',
                textAlign: { xs: 'center', sm: 'left' },
                maxWidth: { md: 400 },
            }}
        >
            {`\u00a9 Copyright ${new Date().getFullYear()} Marex. Neon is a registered trademark of Marex Spectron Group Ltd. For more info, visit `}
            <Link
                href="https://www.marex.com"
                target="_blank"
                rel="noreferrer"
                sx={{ color: 'link.default' }}
            >
                marex.com
            </Link>
        </Typography>
    </Box>
);
